"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["action", "method"];
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const ValidationText_vue_1 = __importDefault(require("./ValidationText.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SharedForm',
    props: {
        action: {},
        errorMessage: {},
        method: { default: "post" },
        showError: { type: Boolean, default: undefined },
        centeredSubmitButtonSection: { type: Boolean },
        noSubmitButtonGap: { type: Boolean }
    },
    emits: ["submit"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const props = __props;
        const emit = __emit;
        const formRef = (0, vue_3.ref)(null);
        const numberOfSubmits = (0, vue_3.ref)(0);
        const formValidationResetControl = (0, vue_3.ref)(0);
        const isFormValid = (0, vue_3.ref)(true);
        const isErrorVisible = (0, vue_3.computed)(() => props.showError !== undefined ? props.showError : numberOfSubmits.value > 0 && !isFormValid.value);
        const defaultErrorMessage = (0, vue_3.computed)(() => {
            const translated = t("shared.form.validationError");
            return props.errorMessage || translated;
        });
        const updateFormValidity = () => {
            var _a;
            // E-Mail muss über sein Pattern geprüft werden und nicht über typeMismatch, was bei checkValidity() auch stattfindet
            let hasError = false;
            if ((_a = formRef.value) === null || _a === void 0 ? void 0 : _a.elements) {
                for (const el of formRef.value.elements) {
                    const element = el;
                    if (element.type === "email" && element.pattern) {
                        const hasEmailError = element.validity.patternMismatch || element.validity.valueMissing;
                        if (hasEmailError)
                            hasError = true;
                    }
                    else {
                        const isValid = element.checkValidity();
                        if (!isValid)
                            hasError = true;
                    }
                }
            }
            return (isFormValid.value = !hasError);
        };
        (0, vue_3.onMounted)(updateFormValidity);
        const handleSubmit = (event) => {
            numberOfSubmits.value += 1;
            if (updateFormValidity()) {
                if (!props.action) {
                    event.preventDefault();
                }
                emit("submit", event);
            }
            else {
                focusFirstInvalidInput();
                event.preventDefault();
            }
        };
        function focusFirstInvalidInput() {
            var _a;
            if ((_a = formRef.value) === null || _a === void 0 ? void 0 : _a.elements) {
                const invalidElement = Array.from(formRef.value.elements).find((el) => !el.checkValidity());
                invalidElement === null || invalidElement === void 0 ? void 0 : invalidElement.focus();
            }
        }
        (0, vue_3.provide)("numberOfSubmits", numberOfSubmits);
        (0, vue_3.provide)("formValidationResetControl", formValidationResetControl);
        (0, vue_3.provide)("hasFormWrapper", true);
        (0, vue_3.provide)("updateFormValidity", updateFormValidity);
        (0, vue_3.provide)("formRef", formRef);
        const resetFormValidation = () => {
            formValidationResetControl.value++;
            numberOfSubmits.value = 0;
        };
        __expose({
            resetFormValidation,
            formValidationResetControl,
            formRef,
            updateFormValidity,
            numberOfSubmits,
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                ref_key: "formRef",
                ref: formRef,
                action: _ctx.action,
                method: _ctx.action && _ctx.method,
                novalidate: "",
                class: "tw",
                onSubmit: handleSubmit
            }, [
                (0, vue_2.renderSlot)(_ctx.$slots, "default"),
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)({ 'm-auto w-full max-w-xs': _ctx.centeredSubmitButtonSection, 'mt-14': !_ctx.noSubmitButtonGap })
                }, [
                    (isErrorVisible.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ValidationText_vue_1.default, {
                            key: 0,
                            class: (0, vue_2.normalizeClass)(["mb-2", { 'text-center': _ctx.centeredSubmitButtonSection }]),
                            "error-message": defaultErrorMessage.value,
                            "no-indent": ""
                        }, null, 8, ["class", "error-message"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.renderSlot)(_ctx.$slots, "submitButton")
                ], 2)
            ], 40, _hoisted_1));
        };
    }
});
